import Collection from 'core/model/Collection';
import DashboardModel from 'app/stores/dashboard/DashboardModel';
import SavedView from 'app/stores/savedView/SavedView';
import BoardModel from 'app/stores/boards/BoardModel';

class LibraryCollection extends Collection {
  fetch = () =>
    // collection is not fetchable
    Promise.resolve();

  get defaultSortState() {
    return {
      field: 'lastViewedDate',
      direction: 'desc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['name']);
  }

  build = (attributes, options = {}) => {
    const { select = false, deserialize = true } = options;
    const ModelClass =
      // eslint-disable-next-line no-nested-ternary
      attributes.type === 'dashboard' ? DashboardModel : attributes.type === 'saved-view' ? SavedView : BoardModel;
    const model = new ModelClass();

    model.store = this.store;
    model.collection = this;
    model.set(deserialize ? model.deserialize(attributes) : attributes);

    if (select) {
      this.selected = model;
    }

    return model;
  };
}

export default LibraryCollection;
